module.exports = "<div class=\"container\">\n\n  <img class=\"icon\" src=\"{{iconUrl}}\"/>\n\n  <p class=\"title app-title\">{{message}}</p>\n\n</div>\n"